<div class="dropdownlist-filter-cell filter-cell">
	<kendo-dropdownlist class="dropdownlist-filter"
						[value]="selectedValue"
						[data]="dropDownData"
						[defaultItem]="''"
						[popupSettings]="{popupClass: 'grid-popup-filter', 'width': 'auto'}"
						(selectionChange)="onDropdownListFilterChange($event)"
						(open)="onDropDownOpen()">
		<ng-template *ngIf="translateSuffix" kendoDropDownListValueTemplate let-dataItem>
			<div *ngIf="dataItem">{{ dataItem.concat(translateSuffix) | cpTranslate }}</div>
		</ng-template>
		<ng-template *ngIf="translateSuffix" kendoDropDownListItemTemplate let-dataItem>
			<div *ngIf="dataItem">{{ dataItem.concat(translateSuffix) | cpTranslate }}</div>
		</ng-template>
	</kendo-dropdownlist>

	<span class="clear-icon">
		<span *ngIf="selectedValue" class="k-icon k-i-filter-clear" (click)="onClearFilterClick()"></span>
	</span>
</div>


